module.exports = __webpack_public_path__ + "media/images/frontend/min-b9072c34cdeb4ca511e64b13ca4ba1b8.svg";